<template>
    <div>
      <epsHeader :drawer="$store.state.drawer"></epsHeader><br /><br />
      <v-divider></v-divider>
  
      <TabMenu></TabMenu>
    </div>
  </template>
  
  <script>
  import epsHeader from "../shared/UpdatedHeader";
  import TabMenu from "../shared/UserRoles";
  
  export default {
    components: {
      epsHeader: epsHeader,
      
      TabMenu: TabMenu,
    },
    mounted() {
      
    },
  
    beforeRouteLeave(to, from, next) {
      if (to.path == "/" && localStorage.getItem("EPS-token") != null) {
        console.log("cant");
      } else next();
    },
  };
  </script>
  
  <style scoped>
  /* * {
    background-color: #eaf4ff;
   
  } */
  </style>